module.exports = __webpack_public_path__ + "img/char-mo.77a100e6.svg";